import { Trophy } from "lucide-react";

import { SECTION_TYPES } from "@/lib/constants/sections";
import { constructImageUrl } from "@/lib/utils";

import type { WebsiteWithImages } from "@/types/prisma";

const aboutBenefitsAndAwardsSection = {
  type: SECTION_TYPES.ABOUT_BENEFITS_AND_AWARDS,
  content: {
    header: "Benefits of working with us",
    subheader: "We are proud of our accomplishments and the benefits we provide.",
    benefitsAndAwards: [
      {
        title: "Quick Arrival Time",
        description: "We hold a world record for time delivery.",
        image: "",
      },
      {
        title: "Fair Upfront Prices",
        description: "We hold a world record for time delivery.",
        image: "",
      },
      {
        title: "Emergency Repairs",
        description: "We hold a world record for time delivery.",
        image: "",
      },
      {
        title: "Licensed & Insured",
        description: "Never missed a deadline.",
        image: "",
      },
    ],
  },
  meta: {
    displayName: "Benefits and Awards",
    displayDescription: "Tell your customers about your accomplishments and the benefits you may provide.",
    displayIcon: Trophy,
  },
  aiPrompt(website: WebsiteWithImages) {
    const images = website.images.map((image) => constructImageUrl(image.providerId, image.source!));

    return `For the Benefits and Awards section, showcase the company's achievements, accolades, and unique selling points. 
    Use a combination of text and images to make the content more engaging and memorable. 
    Highlight the benefits that customers can expect when choosing the company's products or services. 
    Pick an image for each individual entry from the following images, make sure each is unique: ${
      images
        ? images.join(" | ") +
          "\nYOU ARE TO ONLY USE IMAGE URLS FROM THE PROVIDED IMAGE URLS AND NOT MAKE UP OF ANY URL."
        : ""
    }`;
  },
};

export default aboutBenefitsAndAwardsSection;
